import { Observer } from "mobx-react";

import QuestionareStore from "../../stores/QuestionareStore";
import styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import { getMobileOperatingSystem } from "../../../constants/utils"
import ArrowLeft from "../../../components/ArrowLeft";
import ArrowRight from "../../../components/ArrowRight";

const FooterHindi = ({ isQuestionScreen }) => {
  const isiOS = getMobileOperatingSystem() === "iOS";
  return (
    <Observer>
      {() => {
        const isNextDisabled =
          QuestionareStore.isNextButtonDisabled(isQuestionScreen);
        const isBackDisabled = QuestionareStore.currentStepIndex == 0;

        return (
          <div className={styles.FooterBar}>
          <button
            className={isiOS ? iStyles.BackBtn : styles.BackBtn}
            style={{ opacity: isBackDisabled ? 0.5 : 1 }}
            disabled={isBackDisabled}
            onClick={() => QuestionareStore.handleBackPress()}
            type="button"
          >
            {/* <ArrowLeft /> */}
            {'पीछे जाएँ'}
          </button>
          <button
            className={isiOS ? iStyles.NextBtn : styles.NextBtn}
            style={{ opacity: isNextDisabled ? 0.5 : 1 }}
            disabled={isNextDisabled}
            onClick={() => QuestionareStore.handleNextPress()}
            type="button"
          >
            {/* <ArrowRight /> */}
            {'आगे जाएँ'}
          </button>
        </div>
        );
      }}
    </Observer>
  );
};

export default FooterHindi;
